import Vue from 'vue'
import Vuetify from 'vuetify'
import VueObserveVisibility from 'vue-observe-visibility'

Vue.use(VueObserveVisibility)
Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#112244',
        info: '#E8D121'
      }
    }
  }
})
